import {createWorkerWebSocket} from '@app/commons/collaboration/worker-socket';
export function getWorkerSocket() {
  if (typeof Worker === 'undefined') return window.WebSocket;
  return createWorkerWebSocket(() => new Worker(new URL('./yjs-transport.worker.js', import.meta.url)));
}
